export const getMetaTitle = (prefix: string) => prefix + " | " + "Coach Mate";
